// extracted by mini-css-extract-plugin
export var filterIncDec = "_dz-0";
export var leftBorder = "_dz-1";
export var rightBorder = "_dz-2";
export var stringInput = "_dz-3";